import {
  Grid,
  IconButton,
  Stack,
  Typography,
  alpha,
  useTheme,
} from "@mui/material";
import { useEffect } from "react";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import MicIcon from "@mui/icons-material/Mic";
import { useTranslation } from "react-i18next";
import FormInput from "../../../components/UI/Inputs/FormInput";
import { useFormContext } from "react-hook-form";
import { TAppointment } from "../NewTriage/schema";

const translationPath = "page.triageEmergencyDepartment.";

interface IAutoCompleteVoiceProps {
  label: string;
  SearchAsYouTypeParams?: (typedValue: string) => any;
  params?: any;
}

const AutoCompleteVoiceTriage = ({
  label,
  SearchAsYouTypeParams,
  params,
}: IAutoCompleteVoiceProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const {
    listening,
    browserSupportsSpeechRecognition,
    isMicrophoneAvailable,
    resetTranscript,
    finalTranscript,
  } = useSpeechRecognition();

  const { setValue } = useFormContext<TAppointment>();

  useEffect(() => {
    const onSearch = (position: GeolocationPosition) => {
      const coords = position.coords;
      localStorage.setItem(
        "coords",
        JSON.stringify({ lat: coords.latitude, lng: coords.longitude })
      );
      setValue("anamnesis", finalTranscript);
      resetTranscript();
    };
    setTimeout(() => {
      if (finalTranscript) navigator.geolocation.getCurrentPosition(onSearch);
      SpeechRecognition.stopListening();
    }, 500);
  }, [finalTranscript, setValue, resetTranscript]);

  const LIGHT_COLOR = alpha(theme.palette.primary.light, 0.5);
  const DARK_COLOR = alpha(theme.palette.primary.dark, 0.5);

  return (
    <Grid container>
      <Stack
        direction={"row"}
        alignItems={"center"}
        width={"100%"}
        position={"relative"}
      >
        <FormInput
          autoFocus={true}
          size="small"
          name="anamnesis"
          placeholder={`${t(translationPath + "anamnesis")}`}
          fullWidth
          multiline
          minRows={4}
          sx={(t) => ({
            width: "97%",
            ".MuiOutlinedInput-root": {
              borderRadius: 2,
            },
            ".MuiOutlinedInput-notchedOutline": {
              borderColor:
                t.palette.mode === "light"
                  ? t.palette.primary.light
                  : t.palette.primary.dark,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor:
                t.palette.mode === "light"
                  ? t.palette.primary.dark + " !important"
                  : t.palette.primary.light + " !important",
            },
          })}
        />
        <Stack position={"absolute"} right={0} zIndex={10}>
          <IconButton
            size="large"
            sx={(theme) => ({
              backgroundColor:
                theme.palette.mode === "light"
                  ? theme.palette.primary.light
                  : theme.palette.primary.dark,
              ":hover": {
                backgroundColor:
                  theme.palette.mode === "light"
                    ? theme.palette.primary.dark
                    : theme.palette.primary.light,
              },
              color: listening ? "#ff0000" : "#fff",
              outline: listening
                ? `15px solid ${
                    theme.palette.mode === "light" ? LIGHT_COLOR : DARK_COLOR
                  }`
                : "",
            })}
            onClick={() => {
              if (!listening)
                SpeechRecognition.startListening({ continuous: true });
              if (listening) SpeechRecognition.stopListening();
              // if (onSearch.length !== 0) {
              //   navigator.geolocation.getCurrentPosition(onSearch);
              // }
            }}
          >
            <MicIcon />
          </IconButton>
        </Stack>
      </Stack>
      {!isMicrophoneAvailable && (
        <Typography
          variant="body2"
          sx={(theme) => ({
            color: theme.palette.error.main,
            fontSize: 12,
          })}
          mt={1}
        >
          {t("components.autoCompleteVoice.permission")}
        </Typography>
      )}
      {!browserSupportsSpeechRecognition && (
        <Typography
          variant="body2"
          sx={(theme) => ({
            color: theme.palette.error.main,
            fontSize: 12,
          })}
          mt={1}
        >
          {t("components.autoCompleteVoice.support")}
        </Typography>
      )}
    </Grid>
  );
};

export default AutoCompleteVoiceTriage;
